import { render, staticRenderFns } from "./AydinlatmaMetniKabul.vue?vue&type=template&id=57f477c9&"
import script from "./AydinlatmaMetniKabul.vue?vue&type=script&lang=js&"
export * from "./AydinlatmaMetniKabul.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports